import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";

import { useSpecieVarietyLookups, useSpecieVariety, useSaveSpecieVariety } from "./useSpecieVariety";
import { transformCropsWithSagIcon } from "@/utils/cropOptions.utils";

export function useSpecieVarietyForm({ option, filters, elementId, baseObject, onClose }) {
	const isOpen = option === "crear" || option === "editar";
	const isEditMode = option === "editar";
	const modalTitle = useMemo(() => (isEditMode ? "Editar Especies y Variedades" : "Crear Especies y Variedades"), [isEditMode]);

	const { mutate: saveSpecieVariety, isLoading: isLoadingSave } = useSaveSpecieVariety();
	const { data: lookups, isLoading: isLoadingLookups } = useSpecieVarietyLookups();

	const canLoadDetail = isEditMode && !!elementId && !!lookups && !isLoadingLookups;
	const { data: element, isLoading: isLoadingElement, isFetching: isFetchingElement } = useSpecieVariety(filters, elementId, canLoadDetail);

	const [formState, setFormState] = useState({ ...baseObject });
	const [formErrors, setFormErrors] = useState({});

	useEffect(() => {
		if (isEditMode && element) {
			setFormState((prev) => ({
				...prev,
				...element,
			}));
		}
	}, [isEditMode, element]);

	const validateForm = (state) => {
		const next = {};
		if (!state.specie) next.specie = "Requerido";
		if (!state.varieties?.length) next.varieties = "Requerido";
		return next;
	};

	const buildPayload = (state) => {
		const specieObject = typeof state.specie === "number" ? (lookups?.crops || []).find((c) => c.value === state.specie) || null : null;

		const varietiesObjects = (state.varieties || []).map((varietyId) => {
			return (state.varieties_options || []).find((v) => v.value === varietyId) || { value: varietyId, label: varietyId };
		});

		return {
			form: {
				id: isEditMode ? Number(elementId) : undefined,
				specie: state.specie,
				varieties: state.varieties || [],
				specie_object: specieObject,
				varieties_objects: varietiesObjects,
			},
			filters: filters,
		};
	};

	const handleSubmit = async (event) => {
		event.preventDefault();

		const nextErrors = validateForm(formState);
		setFormErrors(nextErrors);
		if (Object.keys(nextErrors).length) return;

		const payload = buildPayload(formState);

		saveSpecieVariety(payload, {
			onSuccess: () => {
				toast.success(isEditMode ? "Especies y Variedades actualizado" : "Especies y Variedades creado");
				onClose();
			},
			onError: (error) => {
				toast.error(<div style={{ whiteSpace: "pre-line" }}>{error?.response?.data?.message || "Error al guardar Especies y Variedades"}</div>);
			},
		});
	};

	const cropsOptions = useMemo(() => {
		return transformCropsWithSagIcon(lookups?.crops);
	}, [lookups]);

	return {
		isOpen,
		isEditMode,
		modalTitle,
		isLoadingLookups,
		isLoadingSave,
		isLoadingElement,
		isFetchingElement,

		cropsOptions,

		formState,
		setFormState,
		formErrors,
		setFormErrors,

		handleSubmit,
	};
}
